import { FC, memo } from 'react'
import dynamic from 'next/dynamic'

const TextEditor = dynamic(() => import('./Component'), {
  ssr: false,
})

export type TextEditorProps = {
  initialHtml: any
  setHtml: (html: string) => void
  readOnly?: boolean
  modules?: any
}

const FullPageTextEditor: FC<TextEditorProps> = (props) => {
  return <TextEditor {...props} />
}

export default memo(FullPageTextEditor)
